export enum Font {
    Default = '-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji',
    Monospace = 'SFMono-Regular,Consolas,Liberation Mono,Menlo,monospace',
}
